module.exports = __webpack_public_path__ + "static/img/u71.f798223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u71.png
// module id = pglU
// module chunks = 1